const initialState = {
  notes: { type: 'note', title: '', text: '', id: '' },
  tasks: { type: 'tasks', check: false, content: '', id: '' },
};

export default initialState;
